import { boAPI } from 'constants/api';
import fetchApi from 'services/fetch';
import { track, generateServerResponseError, generateMessageDisplayedSegment } from 'utils/segmenTracker';
import { ACTIVATION, SERVER_RESPONSE_FAILED, MESSAGE_DISPLAYED } from 'constants/segmentEvents';
import secureStorage from 'utils/secureWebStorage';

const initialState = {
  data: {},
  isLoggedIn: false,
};

export const auth = {
  state: { ...initialState },
  reducers: {
    updateAuthData(state, payload) {
      return {
        ...state,
        data: { ...state.data, ...payload },
      };
    },
    updateLoggedInStatus(state, payload) {
      return {
        ...state,
        isLoggedIn: payload,
      };
    },
  },
  effects: (dispatch) => {
    return {
      async authenticate() {
        dispatch.apiStatus.setProcessing(true);
        return fetchApi({
          method: 'POST',
          url: boAPI.accessToken,
        })
          .then((res) => {
            dispatch.auth.updateLoggedInStatus(true);
            secureStorage.setItem('BEPubKey', res?.data?.publicJwk);
            dispatch.apiStatus.setProcessing(false);
            return Promise.resolve({ success: true });
          })
          .catch((error) => {
            dispatch.apiStatus.setRequestFailed({ ...error });
            track(SERVER_RESPONSE_FAILED, {
              ...generateServerResponseError(error, ACTIVATION, 'Splash Screen', boAPI.accessToken, 'Access Token API'),
            });
            track(MESSAGE_DISPLAYED, { ...generateMessageDisplayedSegment(error, ACTIVATION, 'Access Token API') });
            return Promise.resolve({ success: false });
          });
      },
      async clearStore() {},
    };
  },
};
